<template lang="pug">
  .count-down
    .time-item {{ timeInfo.hours[0] }}
    .time-item {{ timeInfo.hours[1] }}
    span.sp :
    .time-item {{ timeInfo.minutes[0] }}
    .time-item {{ timeInfo.minutes[1] }}
    span.sp :
    .time-item {{ timeInfo.seconds[0] }}
    .time-item {{ timeInfo.seconds[1] }}
</template>
<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      countDown: 0,
      timeInfo: this.getDiffTime(),
    };
  },
  mounted() {
    this.countDown = setInterval(() => {
      this.timeInfo = this.getDiffTime();
    }, 1000);
  },
  destroyed() {
    if (this.countDown) {
      clearInterval(this.countDown);
    }
  },
  methods: {
    getDiffTime() {
      const now = dayjs();
      const endOfDay = dayjs().endOf('day').add(1, 'millisecond');
      let diffMs = endOfDay.diff(now);
      if (diffMs < 0) {
        diffMs = 0;
        clearInterval(this.countDown);
      }
      const totalSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = (n) => String(n).padStart(2, '0');
      const padHours = pad(hours);
      const padMinutes = pad(minutes);
      const padSeconds = pad(seconds);
      return {
        hours: padHours,
        minutes: padMinutes,
        seconds: padSeconds,
        hoursArr: padHours.split(''),
        minutesArr: padMinutes.split(''),
        secondsArr: padSeconds.split(''),
      };
    },
  },
};
</script>

<style lang="less" scoped>
.count-down {
  display: flex;
  align-items: center;

  .time-item {
    width: 0.13rem;
    height: 0.16rem;
    background: #cc4432;
    border-radius: 0.03rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.02rem;
  }

  .sp {
    margin-left: 0.03rem;
    margin-right: 0.01rem;
  }
}
</style>
